import { render, staticRenderFns } from "./SSort.vue?vue&type=template&id=7a520e5a&scoped=true&"
import script from "./SSort.vue?vue&type=script&lang=js&"
export * from "./SSort.vue?vue&type=script&lang=js&"
import style0 from "./SSort.vue?vue&type=style&index=0&id=7a520e5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a520e5a",
  null
  
)

export default component.exports